// extracted by css-extract-rspack-plugin
export default {"cls1":"SelectionCitation-cls1_KY7","cls2":"SelectionCitation-cls2_qDp SelectionCitation-cls1_KY7"};